import { Box, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import useIsIntegrated from "../../../../api/hooks/useIsIntegrated";
import SecondaryButton from "../../../../components/buttons/SecondaryButton";
import useExpandedList from "../../../../components/hooks/ExpandedList";
import LoadingIcon from "../../../../components/LoadingIcon";
import { ScreenshotAccordion } from "../../../../components/ScreenshotAccordion";
import { logos } from "../../environment/icons/iconExport";
import Guideline from "../components/Guideline";
import GuidelineStep from "../components/GuidelineStep";
import GuidelineStepByStep from "../components/GuidelineStepByStep";
import IntegrationGuideAlert from "../components/IntegrationGuideAlert";
import perceptionPointProfileApiKey from "./images/perception-point-profile-api-key.png.png";
import PerceptionPointConnectForm from "./PerceptionPointConnectForm";

const PerceptionPointIntegration = () => {
  const [searchParams] = useSearchParams();
  const [guideMode, setGuideMode] = useState(false);

  useEffect(() => {
    if (searchParams.has("viewonly")) {
      setGuideMode(true);
    }
  }, [searchParams]);

  const { isIntegrated, isIntegratedLoading } =
    useIsIntegrated("perception_point");
  const { handleExpandAll, handleCollapseAll, addToExpandedList } =
    useExpandedList();

  return (
    <Box>
      <Guideline
        title={
          !isIntegrated
            ? "Once integrated, the Breeze platform will automatically read the configurations from Perception Point and prioritize the suggested remediation."
            : ""
        }
        image={logos.PerceptionPoint}
        iconBorderRadius={0}
        name={"Perception Point"}
        content={
          isIntegratedLoading ? (
            <LoadingIcon size={25} />
          ) : isIntegrated && !guideMode ? (
            <Box>
              <Typography variant={"h4"}>
                Perception Point is integrated!
              </Typography>
            </Box>
          ) : (
            <div>
              {/* BUTTONS TO CONTROL EXPANSION */}
              <Box mb="20px">
                <Grid container spacing={2} direction={"row"}>
                  {guideMode && <IntegrationGuideAlert />}

                  <Grid item>
                    <SecondaryButton onClick={handleExpandAll}>
                      Expand All Screenshots
                    </SecondaryButton>
                  </Grid>
                  <Grid item>
                    <SecondaryButton onClick={handleCollapseAll}>
                      Collapse All Screenshots
                    </SecondaryButton>
                  </Grid>
                </Grid>
              </Box>

              {/* SETUP INSTRUCTIONS */}
              <Box mb="20px">
                <Typography variant="h6">
                  How to connect Perception Point
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 3,
                }}
              >
                <GuidelineStepByStep>
                  <GuidelineStep title="Login to Perception Point" />

                  <GuidelineStep title="Navigate to the Profile page">
                    <Typography variant={"body2"}>
                      Navigate to the Profile page using the left menu.
                    </Typography>
                  </GuidelineStep>

                  <GuidelineStep title="Copy your API key">
                    <Typography variant={"body2"}>
                      Click on the icon next to the blurred API key to reveal
                      and copy it.
                    </Typography>

                    <ScreenshotAccordion
                      images={[
                        {
                          file: perceptionPointProfileApiKey,
                          altext: "Perception Point Profile page with API key",
                        },
                      ]}
                      onExpanded={addToExpandedList}
                    />
                  </GuidelineStep>

                  <GuidelineStep title="Paste the API key here">
                    <Typography variant={"body2"}>
                      Paste the API Key below to connect Perception Point with
                      Breeze.
                    </Typography>
                    <Box width={700}>
                      <PerceptionPointConnectForm guideMode={guideMode} />
                    </Box>
                  </GuidelineStep>
                </GuidelineStepByStep>
              </Box>
            </div>
          )
        }
      />
    </Box>
  );
};

export default PerceptionPointIntegration;
